import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '@app/api/shared';
import {
  SidebarEndpoints as Endpoints,
  type GetSidebarCountersRequest,
  type GetSidebarCountersResponse,
} from '@app/api/Sidebar/types';
import { SIDEBAR_CHUNK } from '@app/constants';

export const sidebarApi = createApi({
  reducerPath: 'sidebarApi',
  baseQuery: createApiBaseQuery(SIDEBAR_CHUNK),
  endpoints: ({ query }) => ({
    [Endpoints.GetSidebarCounters]: query<
      GetSidebarCountersResponse,
      GetSidebarCountersRequest
    >({
      query: (params) => ({
        url: Endpoints.GetSidebarCounters,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const { useGetSidebarCountersQuery, useLazyGetSidebarCountersQuery } =
  sidebarApi;
